import {FormControl, FormField} from 'platform/components';
import {VStack} from 'platform/foundation';

import {UseFormReturn, useWatch} from 'react-hook-form';

import i18n from '@dms/i18n';
import {useBranches} from '@dms/shared';

import {RequiredTestIdProps, suffixTestId} from 'shared/web';

import {FormValues} from '../types/FormValues';

interface UserBranchesProps extends RequiredTestIdProps {
  control: FormControl<FormValues>;
  formApi: UseFormReturn<FormValues>;
}
export function UserBranches(props: UserBranchesProps) {
  const {branchOptions, isLoading: isLoadingBranches} = useBranches();

  const selectedBranches = useWatch({control: props.control, name: 'branchIds'});
  const defaultBranchId = useWatch({control: props.control, name: 'defaultBranchId'});

  const userBranchOptions = branchOptions.filter((item) => selectedBranches?.includes(item.value));

  return (
    <VStack spacing={4}>
      <FormField
        name="branchIds"
        control={props.control}
        type="multiChoice"
        isLoading={isLoadingBranches}
        isRequired
        isSearchable
        options={branchOptions}
        onChange={(value) => {
          if (value?.length === 1 || !value?.includes(defaultBranchId)) {
            props.formApi.setValue('defaultBranchId', value?.[0] as string);
            props.formApi.clearErrors('defaultBranchId');
          }
        }}
        closeMenuOnSelect={false}
        label={i18n.t('entity.branch.labels.userHasAccessToBranches')}
        helperText={i18n.t('entity.branch.labels.branchesHelperText')}
        data-testid={suffixTestId('userBranches-branches', props)}
      />

      <FormField
        name="defaultBranchId"
        control={props.control}
        type="choice"
        isNotClearable
        options={userBranchOptions}
        isRequired
        isDisabled={selectedBranches?.length <= 1}
        label={i18n.t('entity.branch.labels.defaultBranch')}
        helperText={i18n.t('entity.branch.labels.defaultBranchHelperText')}
        data-testid={suffixTestId('userBranches-defaultBranch', props)}
      />
    </VStack>
  );
}
